import template from "./sidebar.html";
import controller from "./sidebar.controller";
import "./sidebar.scss";

export const SidebarComponent = {template, controller};


// WEBPACK FOOTER //
// ./sources/components/layout/sidebar/sidebar.component.js